<template>
  <div
    id="amazon"
    class="te-bg-banner-amazon bg-cover bg-center"
  >
    <div class="co-container-lg mx-auto px-4 py-8">
      <div class="te-amazon-box relative mx-auto flex items-center justify-center overflow-hidden rounded bg-white px-4 py-7 pb-5 md:pb-5">
        <div class="te-amazon-textarea relative flex flex-col items-center md:ml-[5.25rem] md:items-start">
          <div class="te-amazon-circle absolute rounded-full">
            <span class="te-amazon-circle-text co-display-12 block text-center font-bold">今なら</span>
          </div>
          <p class="co-display-10 mb-3 font-bold md:mb-0">
            無料相談を行うと
          </p>
          <div class="te-amazon-textwrap flex flex-col items-center md:flex-row md:items-baseline">
            <div>
              <p class="text-center font-bold">
                <span class="te-text-orange co-display-4 font-bold leading-tight">500</span>
                <span class="te-text-orange co-display-8 font-bold">円分</span>
                <span class="co-display-8 font-bold">の</span>
              </p>
            </div>
            <div>
              <span class="te-amazon-display te-text-orange pl-2 pr-1 font-bold">Amazon</span>
              <span class="te-gift-display te-text-orange font-bold">ギフトカード</span>
            </div>
            <span class="te-text-present font-bold">プレゼント！</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.te-bg-banner-amazon {
  background-image: url('~/assets/images/Te/TeCounseling/AmazonGift/bg_concentrated_line.png');
  background-repeat: no-repeat;
}

.te-amazon-box::before,
.te-amazon-box::after {
  position: absolute;
  display: block;
  width: 10rem;
  height: 2.1875rem;
  content: '';
  background: #ff8181;
}

.te-amazon-box {
  max-width: 58.75rem;
  box-shadow: 1px 3px 0 0 rgba(51, 51, 51, 0.1);
  &::before {
    top: 0;
    left: 0;
    transform: rotate(-45deg) translate(-48px, -38px);
  }
  &::after {
    right: 0;
    bottom: 0;
    transform: rotate(-45deg) translate(48px, 38px);
  }
}

.te-amazon-circle {
  top: 2.325rem;
  left: 1.3125rem;
  width: 3.75rem;
  height: 3.75rem;
  background-color: #fff060;
  @media (min-width: 576px) {
    top: 2.125rem;
    left: 0.625rem;
    width: 4.375rem;
    height: 4.375rem;
  }
  @media (min-width: 768px) {
    top: 0.325rem;
    left: -5.525rem;
    width: 5rem;
    height: 5rem;
  }
  @media (min-width: 992px) {
    top: 0.725rem;
    left: -5.725rem;
  }
}

.te-amazon-circle-text {
  line-height: 3.75rem;
  @media (min-width: 576px) {
    line-height: 4.375rem;
  }
  @media (min-width: 768px) {
    line-height: 5rem;
  }
}

.te-text-orange {
  color: #f99029;
}

.te-text-present {
  font-size: 1.5rem;
  @media (min-width: 992px) {
    font-size: 2.25rem;
  }
}

.te-amazon-display {
  font-size: 2rem;
  @media (min-width: 992px) {
    font-size: 2.5rem;
  }
}

.te-gift-display {
  font-size: 1.75rem;
  @media (min-width: 992px) {
    font-size: 2.25rem;
  }
}
</style>
